import { render, staticRenderFns } from "./account.html?vue&type=template&id=00a3f8bd&scoped=true&external"
import script from "./account.js?vue&type=script&lang=js&external"
export * from "./account.js?vue&type=script&lang=js&external"
import style0 from "./account.scss?vue&type=style&index=0&id=00a3f8bd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3f8bd",
  null
  
)

export default component.exports